import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Solicitar Autorização", -1)
const _hoisted_2 = {
  class: "ant-row",
  style: {"margin-top":"15px","margin-bottom":"15px"}
}
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-16 ant-col-xl-16" }, null, -1)
const _hoisted_6 = {
  class: "ant-col ant-col-xs-4 ant-col-xl-4",
  style: {"padding-right":"5px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_8 = {
  class: "ant-col ant-col-xs-4 ant-col-xl-4",
  style: {"padding-right":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    keyboard: false,
    centered: "",
    width: 600,
    closable: false,
    maskClosable: false,
    title: '',
    footer: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.state.requisitando)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                description: "As pessoas responsáveis serão notificadas. Aguarde a resposta da sua solicitação.",
                style: {"white-space":"pre"},
                type: "info",
                "show-icon": ""
              }))
            : _createCommentVNode("", true),
          (_ctx.state.expirada)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 1,
                description: "Ninguém respondeu sua solicitação. Por favor tente novamente.",
                style: {"white-space":"pre"},
                type: "warning",
                "show-icon": ""
              }))
            : _createCommentVNode("", true),
          (_ctx.state.negada)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 2,
                description: 'Solicitação negada. Resposta: ' + _ctx.state.resposta,
                style: {"white-space":"pre"},
                type: "error",
                "show-icon": ""
              }, null, 8, ["description"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form_item, {
                label: "Detalhes da Solicitação",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.descricao) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.descricao]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_button, {
                size: "large",
                style: {"width":"100%"},
                onClick: _ctx.cancelar
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_button, {
                type: "primary",
                size: "large",
                loading: _ctx.state.requisitando,
                style: {"width":"100%"},
                onClick: _ctx.requisitar
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.state.requisitando ? '' : 'Solicitar'), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}